import { render, staticRenderFns } from "./PowerBI.vue?vue&type=template&id=3de2ce02&scoped=true"
import script from "./PowerBI.vue?vue&type=script&lang=js"
export * from "./PowerBI.vue?vue&type=script&lang=js"
import style0 from "./PowerBI.vue?vue&type=style&index=0&id=3de2ce02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de2ce02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3de2ce02')) {
      api.createRecord('3de2ce02', component.options)
    } else {
      api.reload('3de2ce02', component.options)
    }
    module.hot.accept("./PowerBI.vue?vue&type=template&id=3de2ce02&scoped=true", function () {
      api.rerender('3de2ce02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ServiceDetailConnectionMonitor/components/PowerBI.vue"
export default component.exports